<div class="edd-header">
  <span class="edd-title">Error Details</span>
  <span *ngIf="taskName" class="edd-task-name">{{ taskName }}</span>
</div>

<mat-dialog-content class="edd-content">
  <ng-container *ngIf="errorMessage; else noDetails">
    <pre class="edd-body">{{ errorMessage }}</pre>
  </ng-container>
  <ng-template #noDetails>
    <p class="edd-no-details">
      Full error details are not available in the Task Summary view.<br>
      Switch to the <strong>Task History</strong> tab and find this task to see the complete error message.
    </p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions class="edd-actions">
  <button mat-stroked-button *ngIf="errorMessage" (click)="copy()">
    {{ copied ? 'Copied!' : 'Copy to Clipboard' }}
  </button>
  <button mat-flat-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>
